import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 35 35"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "#FFF",
      "stroke-width": "1.167",
      transform: "translate(0 -1)"
    }, [
      _createElementVNode("rect", {
        width: "33.833",
        height: "33.785",
        x: ".583",
        y: "1.583",
        rx: "15.556"
      }),
      _createElementVNode("path", { d: "M22.75 17.7c2.47 0 4.472-2 4.472-4.467a4.47 4.47 0 0 0-4.472-4.466 4.47 4.47 0 0 0-4.006 6.455c.08.159.106.34.06.512l-.266.994a.58.58 0 0 0 .712.711l.995-.266a.73.73 0 0 1 .514.06c.6.298 1.276.466 1.991.466Z" }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        d: "M9.34 15.853c-.066 1.704.366 4.599 3.274 7.502.701.7 1.402 1.257 2.086 1.698m-3.991-11.876c1.246-1.244 3.234-1.077 4.025.338l.58 1.04c.524.937.314 2.166-.511 2.99q0 0 0 0s-1.001 1 .813 2.812 2.815.813 2.816.812q0 0 0 0c.825-.824 2.056-1.034 2.995-.51l1.04.58c1.418.79 1.585 2.774.34 4.019-.75.747-1.667 1.329-2.68 1.367a8.8 8.8 0 0 1-2.744-.341"
      })
    ], -1)
  ]))]))
}
export default { render: render }